export default __webpack_public_path__ + "static/media/masina.9bcbdc1f.webp";